import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonToolbar,
  CheckPicker,
  Checkbox,
  DatePicker,
  FlexboxGrid,
  Form,
  SelectPicker,
} from "rsuite";

import "./CustomerFilters.css";
import { updateIn } from "json-immut";
import { HelperServices } from "../../../core/services/HelperServices";
import {
  addLabelValue,
  getDaysDuration,
  isNotEmpty,
} from "../../../utils/helpers";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { StoreServices } from "../../../core/services/StoreServices";
import { CustomerServices } from "../../../core/services/CustomerServices";
import { get } from "lodash/fp";
import { CustomerListParams } from "./CustomerDataTypes";
import {
  customerTypeObjArr,
  messageTypeArr,
  orderTimeObjArr,
  orderTimeUnitObjArr,
  ratingObjArr,
  retentionTypeObjArr,
  roleTypeArr,
  statusObjArr,
  orderDayTypeObj,
  dateFormatObj,
  daysOffsetArr,
  eventArr,
  monthArr,
  dayRangeArr,
  searchTypeObjArr,
  activityTypeObjArr,
  genderObjArr,
  religionObjArr,
  operatorsObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import moment from "moment";

export interface PropTypesInterface {
  onSubmit: Function;
  onClear: Function;
  tabViewSelected?: String;
}

export default function CustomerFilters({
  onSubmit,
  onClear,
  tabViewSelected,
}: PropTypesInterface) {
  const { t } = useTranslation();
  const selectedCompany = useSelector((state: any) => state.company);
  const initSearchFormData = {
    fname: "",
    fname_search_type: "starts",
    lname: "",
    email: "",
    username: "",
    store: "",
    gender: "",
    religion: "",
    emp_code: "",
    profession: "",
    designation: "",
    receive_notification: "",
    mobile: "",
    building: "",
    area: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    address_mobile: "",
    next_follow_up: "",
    category_ids: "",
    customer_source: "",
    event_type: "",
    event_month: moment().format("MM"),
    event_week: "",
    created_by: "",
    customer_rating: "",
    customer_type: "",
    retention_type: "",
    not_ordered_since_val: "1",
    not_ordered_since_unit: "",
    not_followed_up: "",
    has_pending_follow_up: "",
    pending_follow_up: "",
    pending_follow_up_op: operatorsObjArr[0].value,
    home_service_count: "",
    home_service_count_op: operatorsObjArr[0].value,
    activity_type: "",
    activity_interval_val: "",
    activity_date_from: null,
    activity_date_to: null,
    status: "",
  };
  const [formData, setFormData] =
    useState<CustomerListParams>(initSearchFormData);
  const [customerCategoryList, setCustomerCategoryList] = useState([] as any);
  const [customerSourceList, setCustomerSourceList] = useState([] as any);
  const [customerCreatedByList, setCustomerCreatedByList] = useState([] as any);
  const [cityList, setCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [buildingList, setBuildingList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const handleSearchToggle = () => setShowFilter(!showFilter);
  const countryList = useSelector((state: any) => state.country.data);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  const handleNotFollowedUpCheck = (value: any, checked: any) => {
    let form = updateIn(formData, ["not_followed_up"], checked ? value : "");
    setFormData(form);
  };

  const handlePendingFollowUpCheck = (value: any, checked: any) => {
    let form = updateIn(
      formData,
      ["has_pending_follow_up"],
      checked ? value : "",
    );
    setFormData(form);
  };

  function init() {
    try {
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (selectedCompany.id) {
      let custDataArr: any[] = [];
      setCustomerCategoryList(custDataArr);
      setCustomerCreatedByList(custDataArr);
      setCustomerSourceList(custDataArr);
      setStoreList([]);
    }
  }, [selectedCompany]);

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex] = date;
    setFormData({ ...frmObj });
  };

  const clearActivityDates = () => {
    formData.activity_date_from = null;
    formData.activity_date_to = null;
    setFormData({ ...formData });
  };

  const setActivityDates = (value: any) => {
    if (value == "custom") {
      clearActivityDates();
      return;
    }
    formData.activity_date_from = new Date(
      moment()
        .add(daysOffsetArr[value as keyof typeof daysOffsetArr].offsetFrom, "d")
        .format(dateFormatObj.moment_y_m_d),
    );
    formData.activity_date_to = new Date(
      moment()
        .add(daysOffsetArr[value as keyof typeof daysOffsetArr].offsetTo, "d")
        .format(dateFormatObj.moment_y_m_d),
    );
    setFormData({ ...formData });
  };

  function getCompanyId(forComp?: number) {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = forComp ? forComp : selectedCompany.id;
    }
    return compId;
  }

  async function getCustomerCategory() {
    if (customerCategoryList.length > 0) {
      return;
    }
    let compId = getCompanyId();
    let custCatArr: any[] = [];

    if (!compId) {
      setCustomerCategoryList(custCatArr);
      return;
    }
    try {
      const res = await CustomerServices.getCustomerCategories({
        company: compId,
      });
      const respData = get("data.data", res);
      if (respData.length) {
        custCatArr = addLabelValue(respData, "category_name", "id");
      }
      setCustomerCategoryList(custCatArr);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function getCustomerSource() {
    if (customerSourceList.length > 0) {
      return;
    }
    let compId = getCompanyId();
    if (!compId) {
      return;
    }
    try {
      const res = await CustomerServices.getCustomerSources({
        company: compId,
      });
      const respData = get("data.data", res);
      setCustomerSourceList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function getCustomerCreatedBy() {
    if (customerCreatedByList.length > 0) {
      return;
    }
    let compId = getCompanyId();
    try {
      const res = await HelperServices.getCreatedByList({
        company: compId,
        for_entity: "customer",
      });
      const respData = get("data.data", res);
      setCustomerCreatedByList(respData);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function storeSearch(searchStore: string, forComp?: number) {
    if (storeList.length > 0) {
      return;
    }
    let compId = getCompanyId(forComp);

    if (!compId) {
      return;
    }
    try {
      const res = await StoreServices.getStores({
        company: compId,
        smart_search: searchStore,
      });
      const respData = get("data.data", res);
      if (respData.length) {
        setStoreList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function handleCountryChange(countryId: number) {
    try {
      const stateRes = await HelperServices.getAllValidStates({
        country: countryId,
      });
      setStateList(get("data.data", stateRes));
      resetSelectionFor("state");
      handleFormChanges({ path: "country", value: countryId });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleStateChange(stateId: number) {
    try {
      const res = await HelperServices.getAllValidCities({ state: stateId });
      setCityList(res.data.data);
      resetSelectionFor("city");
      handleFormChanges({ path: "state", value: stateId });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleCityChange(cityId: number) {
    try {
      const res = await HelperServices.getAllValidAreas({ city: cityId });
      setAreaList(res.data.data);
      resetSelectionFor("area");
      handleFormChanges({ path: "city", value: cityId });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleAreaChange(areaId: number) {
    try {
      const res = await HelperServices.getAllValidBuildings({ area: areaId });
      setBuildingList(res.data.data);
      resetSelectionFor("building");
      handleFormChanges({ path: "area", value: areaId });
    } catch (error) {
      console.log(error);
    }
  }

  function clearSearch() {
    resetSelectionFor("country");
    clearActivityDates();
    onClear();
    setFormData(initSearchFormData);
  }

  function resetSelectionFor(resetFor: string) {
    let resetData: Object = {};
    switch (resetFor) {
      case "country":
        resetData = {
          country: "",
          state: "",
          city: "",
          area: "",
          building: "",
        };
        setStateList([]);
        setCityList([]);
        setAreaList([]);
        setBuildingList([]);
        break;
      case "state":
        resetData = {
          state: "",
          city: "",
          area: "",
          building: "",
        };
        setCityList([]);
        setAreaList([]);
        setBuildingList([]);
        break;
      case "city":
        resetData = {
          city: "",
          area: "",
          building: "",
        };
        setAreaList([]);
        setBuildingList([]);
        break;
      case "area":
        resetData = {
          area: "",
          building: "",
        };
        setBuildingList([]);
        break;
      case "building":
        resetData = {
          building: "",
        };
        break;
    }
    let newFormData = {
      ...formData,
      ...resetData,
    };
    setFormData(newFormData);
  }

  const handleRecNotificationCheck = (value: any, checked: any) => {
    let form = updateIn(
      formData,
      ["receive_notification"],
      checked ? value : "",
    );
    setFormData(form);
  };

  return (
    <div>
      <div className="row mb-2 mb-hide">
        <ButtonToolbar>
          <Button onClick={handleSearchToggle}>{t("ADVANCE_SEARCH")}</Button>
        </ButtonToolbar>
      </div>
      {showFilter && (
        <div className="content mb-3 pb-0">
          <Form
            formValue={formData}
            onChange={(data: any) => {
              let form = { ...formData, ...data };
              setFormData(form);
            }}
            layout="inline"
          >
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="fname">
                  <Form.ControlLabel>{t("FIRST_NAME")}</Form.ControlLabel>
                  <SelectPicker
                    data={searchTypeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "fname_search_type", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "fname_search_type",
                        value: "",
                      });
                    }}
                    name="fname_search_type"
                    value={formData?.fname_search_type}
                  />
                  <Form.Control name="fname" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="lname">
                  <Form.ControlLabel>{t("LAST_NAME")}</Form.ControlLabel>
                  <Form.Control name="lname" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="email">
                  <Form.ControlLabel>{t("EMAIL")}</Form.ControlLabel>
                  <Form.Control name="email" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="username">
                  <Form.ControlLabel>{t("USERNAME")}</Form.ControlLabel>
                  <Form.Control name="username" />
                </Form.Group>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item>
                <Form.Group controlId="profession">
                  <Form.ControlLabel>{t("PROFESSION")}</Form.ControlLabel>
                  <Form.Control name="profession" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="designation">
                  <Form.ControlLabel>{t("DESIGNATION")}</Form.ControlLabel>
                  <Form.Control name="designation" />
                </Form.Group>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item>
                <Form.Group controlId="mobile">
                  <Form.ControlLabel>{t("MOBILE")}</Form.ControlLabel>
                  <Form.Control name="mobile" type="number" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="pincode">
                  <Form.ControlLabel>{t("PINCODE")}</Form.ControlLabel>
                  <Form.Control name="pincode" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="receive_notification">
                  <Form.ControlLabel>
                    {t("RECEIVE_NOTIFICATION")}
                  </Form.ControlLabel>
                  <Checkbox
                    name="receive_notification"
                    value={1}
                    onChange={handleRecNotificationCheck}
                    checked={formData.receive_notification == "" ? false : true}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="status">
                  <Form.ControlLabel>{t("STATUS")}</Form.ControlLabel>
                  <SelectPicker
                    data={statusObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "status", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "status", value: "" });
                    }}
                    name="status"
                    value={formData?.status}
                  />
                </Form.Group>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item>
                <Form.Group controlId="country">
                  <Form.ControlLabel>{t("Country")}</Form.ControlLabel>
                  <SelectPicker
                    data={countryList}
                    valueKey="id"
                    labelKey="country_name"
                    onSelect={(value, item) => {
                      handleCountryChange(value);
                    }}
                    onClean={(e: any) => {
                      resetSelectionFor("country");
                    }}
                    name="country"
                    value={formData?.country}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="state">
                  <Form.ControlLabel>{t("STATE")}</Form.ControlLabel>
                  <SelectPicker
                    data={stateList}
                    valueKey="id"
                    labelKey="state_name"
                    onSelect={(value, item) => {
                      handleStateChange(value);
                    }}
                    onClean={(e: any) => {
                      resetSelectionFor("state");
                    }}
                    name="state"
                    value={formData?.state}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="city">
                  <Form.ControlLabel>{t("CITY")}</Form.ControlLabel>
                  <SelectPicker
                    data={cityList}
                    valueKey="id"
                    labelKey="city_name"
                    onSelect={(value, item) => {
                      handleCityChange(value);
                    }}
                    onClean={(e: any) => {
                      resetSelectionFor("city");
                    }}
                    name="city"
                    value={formData?.city}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="area">
                  <Form.ControlLabel>{t("AREA")}</Form.ControlLabel>
                  <SelectPicker
                    data={areaList}
                    valueKey="id"
                    labelKey="area_name"
                    onSelect={(value, item) => {
                      handleAreaChange(value);
                    }}
                    onClean={(e: any) => {
                      resetSelectionFor("area");
                    }}
                    name="area"
                    value={formData?.area}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="building">
                  <Form.ControlLabel>{t("BUILDING")}</Form.ControlLabel>
                  <SelectPicker
                    data={buildingList}
                    valueKey="id"
                    labelKey="building_name"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "building", value });
                    }}
                    onClean={(e: any) => {
                      resetSelectionFor("building");
                    }}
                    name="building"
                    value={formData?.building}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>

            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="store">
                  <Form.ControlLabel>{t("STORE")}</Form.ControlLabel>
                  <SelectPicker
                    data={storeList}
                    onOpen={() => storeSearch("")}
                    onSearch={(e: any) => {
                      if (e) {
                        storeSearch(e);
                      }
                    }}
                    valueKey="id"
                    labelKey="store_name"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "store", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "store", value: "" });
                    }}
                    name="store"
                    value={formData?.store}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="customer_type">
                  <Form.ControlLabel>
                    {t("CUSTOMER")} {t("TYPE")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={customerTypeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "customer_type", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "customer_type", value: "" });
                    }}
                    name="customer_type"
                    value={formData?.customer_type}
                  />
                </Form.Group>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item>
                <Form.Group controlId="retention_type">
                  <Form.ControlLabel>
                    {t("RETENTION")} {t("TYPE")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={retentionTypeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "retention_type", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "retention_type", value: "" });
                    }}
                    name="retention_type"
                    value={formData?.retention_type}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="not_ordered_since_val">
                  <Form.ControlLabel>
                    {t("NOT")} {t("ORDERED")} {t("SINCE")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={orderTimeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "not_ordered_since_val",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "not_ordered_since_val",
                        value: "",
                      });
                    }}
                    name="not_ordered_since_val"
                    value={formData?.not_ordered_since_val}
                    defaultValue={orderTimeObjArr[0].value}
                  />
                  <SelectPicker
                    data={orderTimeUnitObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "not_ordered_since_unit",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "not_ordered_since_unit",
                        value: "",
                      });
                    }}
                    name="not_ordered_since_unit"
                    value={formData?.not_ordered_since_unit}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="not_followed_up">
                  <Form.ControlLabel>
                    {t("NOT")} {t("FOLLOWED")} {t("UP")}
                  </Form.ControlLabel>
                  <Checkbox
                    name="not_followed_up"
                    value={1}
                    onChange={handleNotFollowedUpCheck}
                    checked={formData.not_followed_up == "" ? false : true}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="customer_rating">
                  <Form.ControlLabel>
                    {t("CUSTOMER")} {t("RATING")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={ratingObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "customer_rating", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "customer_rating", value: "" });
                    }}
                    name="customer_rating"
                    value={formData?.customer_rating}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="activity_interval_val">
                  <SelectPicker
                    data={activityTypeObjArr}
                    placeholder={t("SELECT") + " " + t("ACTIVITY")}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "activity_type",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "activity_type",
                        value: "",
                      });
                    }}
                    name="activity_type"
                    value={formData?.activity_type}
                  />
                  <SelectPicker
                    data={orderDayTypeObj.all.daysOptions}
                    placeholder={t("DATE") + " " + t("RANGE")}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      setActivityDates(value);
                      handleFormChanges({
                        path: "activity_interval_val",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "activity_interval_val",
                        value: "",
                      });
                    }}
                    name="activity_interval_val"
                    value={formData?.activity_interval_val}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="activity_date_from">
                  <Form.ControlLabel>{t("FROM")}</Form.ControlLabel>
                  <DatePicker
                    value={formData?.activity_date_from}
                    format={dateFormatObj.calendar_d_m_y}
                    name="activity_date_from"
                    id="activity_date_from"
                    onChange={(e: any) => {
                      handleDateChange(e, "activity_date_from");
                    }}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="activity_date_to">
                  <Form.ControlLabel>{t("TO")}</Form.ControlLabel>
                  <DatePicker
                    value={formData?.activity_date_to}
                    format={dateFormatObj.calendar_d_m_y}
                    name="activity_date_to"
                    onChange={(e: any) => {
                      handleDateChange(e, "activity_date_to");
                    }}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="pending_follow_up_op">
                  <Form.ControlLabel>
                    {t("PENDING")} {t("TICKETS")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={operatorsObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "pending_follow_up_op",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "pending_follow_up_op",
                        value: "",
                      });
                    }}
                    name="pending_follow_up_op"
                    value={formData.pending_follow_up_op}
                    defaultValue={operatorsObjArr[0].value}
                  />
                  <Form.Control name="pending_follow_up" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="customer_source">
                  <Form.ControlLabel>
                    {t("CUSTOMER")} {t("SOURCE")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={customerSourceList}
                    valueKey="id"
                    labelKey="source_name"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "customer_source",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "customer_source",
                        value: "",
                      });
                    }}
                    name="customer_source"
                    value={formData?.customer_source}
                    onOpen={() => getCustomerSource()}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="category_ids">
                  <Form.ControlLabel>
                    {t("CUSTOMER")} {t("CATEGORY")}
                  </Form.ControlLabel>
                  <CheckPicker
                    sticky
                    onChange={(e: any) => {
                      let custCat: any = e.filter(isNotEmpty);
                      if (e.length) {
                        handleFormChanges({
                          path: "category_ids",
                          value: custCat.toString(),
                        });
                      } else {
                        handleFormChanges({
                          path: "category_ids",
                          value: "",
                        });
                      }
                    }}
                    onClean={() => {
                      handleFormChanges({
                        path: "category_ids",
                        value: "",
                      });
                    }}
                    data={customerCategoryList}
                    value={formData?.category_ids?.split(",")}
                    onOpen={() => getCustomerCategory()}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid>
              <FlexboxGrid.Item>
                <Form.Group controlId="event_type">
                  <Form.ControlLabel>{t("EVENT")}</Form.ControlLabel>
                  <SelectPicker
                    data={eventArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "event_type",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "event_type",
                        value: "",
                      });
                    }}
                    name="event_type"
                    value={formData?.event_type}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="event_month">
                  <Form.ControlLabel>
                    {t("EVENT")} {t("MONTH")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={monthArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "event_month",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "event_month",
                        value: "",
                      });
                    }}
                    name="event_month"
                    value={formData?.event_month}
                  />
                  <SelectPicker
                    data={dayRangeArr}
                    placeholder={t("WEEK")}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "event_week",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "event_week",
                        value: "",
                      });
                    }}
                    name="event_week"
                    value={formData?.event_week}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="created_by">
                  <Form.ControlLabel>
                    {t("CUSTOMER")} {t("CREATED")} {t("BY")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={customerCreatedByList}
                    valueKey="id"
                    labelKey="name"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "created_by",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "created_by",
                        value: "",
                      });
                    }}
                    name="created_by"
                    value={formData?.created_by}
                    onOpen={() => getCustomerCreatedBy()}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="gender">
                  <Form.ControlLabel>{t("GENDER")}</Form.ControlLabel>
                  <SelectPicker
                    data={genderObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "gender", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "gender", value: "" });
                    }}
                    name="gender"
                    value={formData?.gender}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="home_service_count_op">
                  <Form.ControlLabel>
                    {t("HOME")} {t("SERVICE")} {t("COUNT")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={operatorsObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "home_service_count_op",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "home_service_count_op",
                        value: "",
                      });
                    }}
                    name="home_service_count_op"
                    value={formData.home_service_count_op}
                    defaultValue={operatorsObjArr[0].value}
                  />
                  <Form.Control name="home_service_count" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="religion">
                  <Form.ControlLabel>{t("RELIGION")}</Form.ControlLabel>
                  <SelectPicker
                    data={religionObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "religion", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "religion", value: "" });
                    }}
                    name="religion"
                    value={formData?.religion}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>

            <div className="filter-btn">
              <Button onClick={() => clearSearch()}>{t("CLEAR_FILTER")}</Button>
              <Button onClick={() => onSubmit(formData)}>{t("SEARCH")}</Button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
}
